import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InventoryTransactionsPeriodSum  {
    _originalTypeClassName = "zERP.BO.InventoryTransactionsPeriodSum";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InventoryTransactionsPeriodSum.translate = translateService;
}
this.UnitsIn = null;
this.ValueIn = null;
this.UnitsOut = null;
this.ValueOut = null;
this.InventoryTransactionsPeriodSumKey = null;
this._key = this.InventoryTransactionsPeriodSumKey = 0; 
}

static translate: TranslateService;
_key: any;
UnitsIn:any;
ValueIn:any;
UnitsOut:any;
ValueOut:any;
private _InventoryTransactionsPeriodSumKey:any;
get InventoryTransactionsPeriodSumKey(): any {
    return this._InventoryTransactionsPeriodSumKey;
  }
set InventoryTransactionsPeriodSumKey(value: any) {
    this._InventoryTransactionsPeriodSumKey = value;
    this._key = value;
  }

static AddTransfer($this: any, transfer: any): any{$this.UnitsIn = Joove.Common.safeNumber($this?.UnitsIn) + Joove.Common.safeNumber(((CLMS.Framework.Number.GreaterThan(() => transfer.Quantity, () => 0) ? transfer?.Quantity : 0)));
$this.ValueIn = Joove.Common.safeNumber($this?.ValueIn) + Joove.Common.safeNumber(((CLMS.Framework.Number.GreaterThan(() => transfer.Quantity, () => 0) ? Joove.Common.safeNumber(transfer?.Quantity) * Joove.Common.safeNumber(transfer?.CostPerUnit) : 0)));
$this.UnitsOut = Joove.Common.safeNumber($this?.UnitsOut) - Joove.Common.safeNumber(((CLMS.Framework.Number.GreaterThan(() => transfer.Quantity, () => 0) ? 0 : transfer?.Quantity)));
$this.ValueOut = Joove.Common.safeNumber($this?.ValueOut) - Joove.Common.safeNumber(((CLMS.Framework.Number.GreaterThan(() => transfer.Quantity, () => 0) ? 0 : Joove.Common.safeNumber(transfer?.Quantity) * Joove.Common.safeNumber(transfer?.CostPerUnit))));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InventoryTransactionsPeriodSumKey == null || $this.InventoryTransactionsPeriodSumKey == 0;
            }


}